import React from 'react';
import { useSelector } from 'react-redux';
import { contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import ContractData from './ContractData';
import Extensions from './Extensions';
import PaymentType from './PaymentType';
import Selection from './Selection';

const Step2 = () => {
	const { selectedProduct } = useSelector(contractGeneratorSelectors.getDataToSubmit);

	const product = useSelector(contractGeneratorSelectors.getProduct(selectedProduct.id));
	const productOption = product.options[selectedProduct.options[selectedProduct.id] || product.selectedOption];

	return (
		<>
			<Selection />
			<Spacer height='xxl' />

			<Extensions />
			<Spacer height='xl' />

			{productOption.canBePayedMonthly && (
				<>
					<PaymentType />
					<Spacer height='xl' />
				</>
			)}

			<ContractData darkened={productOption.canBePayedMonthly} />
		</>
	);
};

export default Step2;
